import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import { getPath } from "./utils/getPath";
import { ProjectOrFolderDownloadModal } from "components/_Modals/ProjectDownloadModal/ProjectOrFolderDownloadModal";
import NiceModal from "@ebay/nice-modal-react";
import type { Project } from "../projectStore";

export const openNodeDownloadModal = (node: NodeApi, project: Project) => {
  if (!node.parent) {
    throw new Error("Node does not have a parent");
  }
  if (!project?.id) {
    throw new Error("Project ID is missing. Cannot open download modal.");
  }
  const path = getPath(node.parent);
  const modalSubtitle = `${node.data.folderName} ${path && `(${path})`}`;
  NiceModal.show(ProjectOrFolderDownloadModal, {
    modalSubtitle,
    projectId: project.id,
    nodeId: node.data.id,
  });

  return null;
};
